import React, { useEffect } from "react";
import { Button } from "primereact/button";
import * as warn from "../../../components/Loading/lottiefiles/warn.json";
import Lottie from "react-lottie";
import { useHistory } from "react-router-dom";

const loadOption = {
    loop: true,
    autoplay: true,
    animationData: warn.default,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
    },
};

export default function P200Overview({ dataDashboard, onClickSrhOnDashBoard, countTimer, onRefreshClick, loadingRefresh }) {
    const history = useHistory();
    const numeral = require("numeral");

    useEffect(() => {}, [dataDashboard]);

    return (
        <div className="layout-dashboard" style={{ display: "flex", justifyContent: "center" }}>
            <Button label={`${countTimer}s.`} icon="pi pi-refresh" className="p-button-rounded p-button-outlined" style={{ position: "absolute", right: 20, marginTop: "-30px" }} onClick={() => onRefreshClick()} />
            {/* <label style={{ position: 'absolute', right: 20, marginTop: '-30px' }}></label> */}
            <div className="p-grid" style={{ marginTop: "5px" }}>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div
                        className="overview-box item1 cursor-mo"
                        onClick={() => {
                            history.push("/208");
                        }}
                    >
                        <i className="overview-icon fas fa-file-contract"></i>

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.totalContract : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>จำนวนสัญญา/เส้นทาง</span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item2">
                        {/* <i className="overview-icon fas fa-calculator"></i>
                        <img alt="babylon-layout" className="overview-icon" src="assets/layout/images/pipe.svg" style={{ width: 51, height: 61 }} />*/}
                        <img alt="babylon-layout" className="overview-icon" src="assets/layout/images/pipe2.png" style={{ width: 62, height: 61 }} />

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? numeral(dataDashboard.totalLength).format("0,0") : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>ความยาวท่อรวม (เมตร)</span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item3">
                        {/* <i className="overview-icon fas fa-money-bill"></i> */}
                        <img alt="babylon-layout" className="overview-icon" src="assets/layout/images/thai-baht2.png" style={{ width: 64, height: 61 }} />

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? numeral(dataDashboard.totalAmount).format("0,0.00") : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>มูลค่าโครงการ(ล้านบาท)</span>
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item7 cursor-mo" onClick={() => onClickSrhOnDashBoard("A")}>
                        <i className="overview-icon fas fa-paste"></i>

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.pendingOrder : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>งานสั่งการเฉพาะอย่างคงค้าง</span>
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item5 cursor-mo" onClick={() => onClickSrhOnDashBoard("D")}>
                        {/* <i className={`overview-icon fas ${dataDashboard.alarmWaitingApproveRequest === "Y" ? "fa-bell noti-alert" : "fa-file-alt"}`}></i> */}
                        {dataDashboard.alarmWaitingApproveRequest === "Y" ? (
                            <i className={`overview-icon`}>
                                <Lottie options={loadOption} height={80} width={80} />
                            </i>
                        ) : (
                            <i className="overview-icon fas fa-file-alt"></i>
                        )}

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.waitingApproveRequest : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>ใบแจ้งฯรออนุมัติ</span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item6 cursor-mo" onClick={() => onClickSrhOnDashBoard("E")}>
                        {/* <i className={`overview-icon fas ${dataDashboard.alarmWaitingApproveReport === "Y" ? "fa-bell noti-alert" : "fa-file-signature"}`}></i> */}
                        {dataDashboard.alarmWaitingApproveReport === "Y" ? (
                            <i className={`overview-icon`}>
                                <Lottie options={loadOption} height={80} width={80} />
                            </i>
                        ) : (
                            <i className="overview-icon fas fa-file-signature"></i>
                        )}

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.waitingApproveReport : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>รายงานผลรออนุมัติ</span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    {/* <div className="overview-box item4 cursor-mo" onClick={() => onClickSrhOnDashBoard("7")}> */}
                    <div className="overview-box item4 cursor-mo" onClick={() => onClickSrhOnDashBoard("C")}>
                        {/* <i className={`overview-icon fas ${dataDashboard.alarmPendingInspect === "Y" ? "fa-bell noti-alert" : "fa-clipboard-check"}`}></i> */}
                        {dataDashboard.alarmPendingInspect === "Y" ? (
                            <i className={`overview-icon`}>
                                <Lottie options={loadOption} height={80} width={80} />
                            </i>
                        ) : (
                            <i className="overview-icon fas fa-clipboard-check"></i>
                        )}
                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.pendingInspectRequest : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>งานรอตรวจสอบหน้างาน</span>
                        </div>
                    </div>
                </div>
                
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item8 cursor-mo" onClick={() => onClickSrhOnDashBoard("B")}>
                        <i className="overview-icon fas fa-business-time"></i>

                        {loadingRefresh === true ? (
                            <div className="overview-numbers">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: "40px" }}></i>
                            </div>
                        ) : (
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.overdueOrder : "-"}</div>
                        )}
                        <div className="overview-subinfo">
                            <span>งานสั่งการเฉพาะอย่างเกินกำหนด</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
